import { useEffect, useState } from "react";

// Service
import CashRegisterService from "../../services/cashRegisterService";

const useCashRegistersById = (IdReg) => {
  const [cashRegister, setCashRegister] = useState(null);

  useEffect(() => {
    if(IdReg) {
      CashRegisterService
        .Get(IdReg)
        .then((res) => setCashRegister(res))
        .catch(err => console.error(err));
    }
  }, [IdReg]);

  return {
    cashRegister,
  };
};

export default useCashRegistersById;
